//chapter1
export default {
    id : 14,//chapter number
    title : '14. Trimming & Forming 공정',//chapter name
    slides : [
        {
            title : 'Intro',
            type : 'intro',
            autoNext : 'N',//Y : yes , N: no
            nextBtn : 'Y',//Y : yes , N: no
            source : 'https://cdn.allwinedu.net/net/contents5/HU12/14/videos/a14.mp4',
        },
        {
            title : 'Today’s Goal',
            type : 'plan',
            autoNext : 'N',//Y : yes , N: no, P : popup
            duration : 20000,// default 20 sec  
            nextBtn : 'Y',//Y : yes , N: no
            body1 : [
                '리드프레임을 사용하는 패키지의 Finishing 공정',
            ],
            body2 : [
                '리드프레임을 사용하는 패키지의 Finishing 공정에 대해 설명할 수 있다.'
            ],
            bgm : "plan.mp3"
        },
        {
            title : 'Lesson',
            type : 'lesson',
            autoNext : 'N',//Y : yes , N: no, P: popup
            nextBtn : 'Y',//Y : yes , N: no
            order : null, // if a chapter have multiple lessons, set order please ex)
            source : 'https://cdn.allwinedu.net/net/contents5/HU12/14/videos/14.mp4',
        },
        {
            title : 'Quiz',
            type : 'quiz',
            quiz : [
                {
                    type : 'ox',
                    title : 'Quiz',
                    question : '트림과 포밍 공정은 리드프레임 형태의 패키지에 대해서만 진행하게 된다.',//html available
                    answer : "1",
                    explain : '트림과 포밍 공정은 리드프레임 형태의 패키지 제조에서만 진행하는 공정이다.'
                },
                {
                    type : 'ox',
                    title : 'Quiz',
                    question : '트림과 포밍은 절단 블레이드가 아닌 금형을 이용해서 공정이 진행된다.',//html available
                    answer : "2",
                    explain : '트림과 포밍은 절단 블레이드가 아닌 트림과 포밍을 하는 금형을 이용해서 작업이 진행된다.'
                },
            ],
            quizMask : "../assets/images/quiz_intro.jpg",//quiz mask bg
            quizMaskStart : "../assets/images/quiz_intro_start.png",//quiz mask bg
            quizIntroText : "../assets/images/quiz_intro_text.png",//quiz mask bg
            bgm : "quiz.mp3"
        },
        {
            title : 'Summary',
            type : 'summary',
            autoNext : 'N',//Y : yes , N: no
            duration : 20000,// default 20 sec  
            nextBtn : 'Y',//Y : yes , N: no
            //download : 'sample.pptx',//data folder
            print : false,// true : show, false: hide
            slides : [
                {
                    body : `<ul>
                        <li>리드프레임을 사용하는 패키지의 Finishing 공정<br>
                        - 반도체 생산을 마무리 하는 단계로 도금 공정, 트림 공정, 포밍 공정을 의미함 <br>
                        - 도금 공정 (Plating) 반도체의 전도성을 증대시키고, 부식을 방지하기 위해 표면에 얇은 층을 입히는 공정<br>
                        - 트림 공정 : 리드프레임의 댐바(Dam bar, Tie bar)를 제거시켜 PKG에 전기적인 성질을 부여하는 공정<br>
                        - 댐바 제거공정(T/R, Trimming) : 댐바(dambar)는 리드와 리드 사이, 몰딩 시에 액체 상태의 컴파운드가 외부 리드로 흘러 넘치는 것을 방지하는 댐 역할을 하며, 이 댐바를 잘라주는 공정을 트리밍(Trimming)이라고 함. 이 금형은 트림 다이라고 함<br>
                        - Forming 공정은 리드를 원하는 형상으로 만드는 공정(J형, 또는 Gull wing 형)</li>
                    </ul>`
                },
            ],
            bgm : "summary.mp3"
        },
        {
            title : 'Outro',
            type : 'outro',
            source : 'https://cdn.allwinedu.net/net/contents5/HU12/14/videos/a14.mp4',
        },
    ]
}